import { Component, h, Host, Prop } from '@stencil/core';
import { SearchResultItem } from '~model/search-result-item';

@Component({
  tag: 'staedtler-search-result-item-product',
})
export class SearchResultItemProduct {
  @Prop() item: SearchResultItem;

  render() {
    return (
      <Host itemScope={'itemScope'} itemType={'http://schema.org/Product'} class="product">
        <picture>
          <source srcSet={this.item.teaserImage[1]} />
          <img
            itemprop="image"
            src={this.item.teaserImage[1]}
            alt={this.item.teaserContent ? this.item.teaserContent : this.item.title}
            title={this.item.title}
            class="img-fluid"
            loading="lazy"
            decoding="async"
          />
          {this.renderSpecial()}
        </picture>

        <span class="name" itemprop="name">
          {this.item.title}
        </span>
        <meta itemprop="brand" content="STAEDTLER" />
        {this.renderSubtitle()}
        {this.renderTeaserContent()}
        {this.renderPrice()}
        <a href={this.item.url} class="link-full" itemprop="url" title={this.item.title} />
      </Host>
    );
  }

  protected renderSubtitle() {
    return this.item.subtitle ? (
      <span class="category" itemprop="category">
        {this.item.subtitle}
      </span>
    ) : (
      ''
    );
  }

  protected renderTeaserContent() {
    return this.item.teaserContent ? (
      <span class="description" itemprop="description">
        {this.item.teaserContent}
      </span>
    ) : (
      ''
    );
  }

  protected renderSpecial() {
    return this.item.isSpecial ? <span class="icon-special">%</span> : '';
  }

  protected renderPrice() {
    return this.item.price ? (
      <span class="prices">
        <span class={this.item.isSpecial ? 'price has-special' : 'price'}>{this.item.price}</span>
        {this.item.isSpecial ? <span class="price-special">{this.item.specialPrice}</span> : ''}
      </span>
    ) : (
      ''
    );
  }
}
